export default __webpack_public_path__ + "static/media/Figure-13.b1ba6cbe.jpg";